/*! GW Wishlist v2 compat | Godha World.
 *  1) Rewires the theme's legacy hover-bar heart (a.wishlist, which linked to /account/login) into the new wishlist.
 *  2) Product page: adds the "Add to wishlist" button under the buy buttons (anchored on the real .product-form__submit).
 *  3) Makes wishlist add-to-cart render the theme's own cart drawer through its official API (cart-drawer.renderContents),
 *     so the drawer, header badge and GoKwik checkout button behave exactly as after a normal product-page add. */
(function () {
  'use strict';
  var G = window.GWWishInternal; if (!G) return;
  var D = document, t;
  var st = D.createElement('style');
  st.textContent = 'a.wishlist.gw-on svg{fill:#e11d48;color:#e11d48}a.wishlist.gw-on svg path{fill:#e11d48;stroke:#e11d48}';
  D.head.appendChild(st);

  function wire() {
    G.$$('a.wishlist').forEach(function (a) {
      if (a.hasAttribute('data-gw-old')) return;
      var card = a.closest('.card-wrapper, .gw-sc__card'); if (!card) return;
      var l = G.$('a[href*="/products/"]', card), m = l && (l.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      a.setAttribute('data-gw-old', '1'); a.setAttribute('data-gw-handle', decodeURIComponent(m[1])); a.setAttribute('href', '/pages/wishlist');
    });
    G.$$('a.wishlist[data-gw-old]').forEach(function (a) {
      var on = G.has(a.getAttribute('data-gw-handle'));
      a.classList.toggle('gw-on', on); a.setAttribute('aria-pressed', on ? 'true' : 'false'); a.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    pdp();
  }
  function pdp() {
    if (!/template-product/.test(D.body.className) || G.$('.gw-wish-btn--pdp')) return;
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var main = G.$('#MainContent') || D, submit = G.$('.product-form__submit', main); if (!submit) return;
    var anchor = submit.closest('.product-form__buttons') || submit.parentElement;
    var b = D.createElement('button');
    b.type = 'button'; b.className = 'gw-wish-btn gw-wish-btn--pdp'; b.setAttribute('data-gw-handle', decodeURIComponent(m[1]));
    b.innerHTML = G.HEART + '<span class="gw-wish-label"></span>';
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
    G.paintAll();
  }
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.wishlist[data-gw-old]'); if (!a) return;
    e.preventDefault(); e.stopPropagation();
    var h = a.getAttribute('data-gw-handle'); if (!h) return;
    if (G.has(h)) { G.remove(h); G.toast('Removed from wishlist'); } else { G.add(h); G.toast('Saved to your wishlist', 'View', null, '/pages/wishlist'); }
  }, true);
  D.addEventListener('gw:wishlist', wire);

  /* ---- cart drawer integration ---- */
  var baseRefresh = G.refreshCart, drawerShown = false;
  G.addToCart = function (items) {
    var body = { items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (j) {
        var cd = D.querySelector('cart-drawer');
        if (cd && typeof cd.renderContents === 'function' && j.sections) {
          try {
            var first = (j.items && j.items[0]) || j;
            cd.renderContents({ id: first.variant_id || first.id, sections: j.sections }); drawerShown = true;
          } catch (e) { drawerShown = false; }
        }
        return j;
      });
  };
  G.refreshCart = function () { if (drawerShown) { drawerShown = false; return Promise.resolve(); } return baseRefresh(); };

  function boot() {
    wire();
    if ('MutationObserver' in window) new MutationObserver(function () { clearTimeout(t); t = setTimeout(wire, 250); }).observe(D.body, { childList: true, subtree: true });
  }
  if (D.readyState === 'complete') boot(); else D.addEventListener('DOMContentLoaded', boot);
})();